import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'morva-dax-help-dialog',
  templateUrl: './dax-help-dialog.component.html',
  styleUrls: ['./dax-help-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DaxHelpDialogComponent implements OnInit {

  constructor(protected dialogRef: NbDialogRef<DaxHelpDialogComponent>) { }

  ngOnInit(): void {
  }

  close(){
    this.dialogRef.close();
  }
}
